import { useCallback } from "react";
import Particles from "react-particles";
//import { loadFull } from "tsparticles"; // if you are going to use `loadFull`, install the "tsparticles" package too.
import { loadSlim } from "tsparticles-slim"; // if you are going to use `loadSlim`, install the "tsparticles-slim" package too.

const Prticless = () => {
    const particlesInit = useCallback(async engine => {
        console.log(engine);
        // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        //await loadFull(engine);
        await loadSlim(engine);
    }, []);

    const particlesLoaded = useCallback(async container => {
        await console.log(container);
    }, []);

    return (
        <Particles
        className="w-100 h-100"
            id="tsparticles"
            init={particlesInit}
            loaded={particlesLoaded}
            options={{
                fullScreen:{
                    enable:"true",
                    // zIndex: -1
                    zIndex: 1
                },
                // background: {
                //     color: {
                //         value: "#0d47a1",
                //     },
                // },
                // fpsLimit: 120,
                particles: {
                  number: { value: 80, density: { enable: true, value_area: 800 } },
                  color: { value: "#31F711" },
                  shape: {
                    type: "circle",
                    stroke: { width: 0, color: "#000000" },
                    polygon: { nb_sides: 5 },
                    image: { src: "img/github.svg", width: 100, height: 100 },
                  },
                  opacity: {
                    value: 0.5,
                    random: false,
                    anim: { enable: false, speed: 1, opacity_min: 0.1, sync: false },
                  },
                  size: {
                    value: 3,
                    random: true,
                    anim: { enable: true, speed: 40, size_min: 0.1, sync: false },
                  },
                  line_linked: {
                    enable: true,
                    distance: 150,
                    color: "#000", //
                    opacity: 0.4,
                    width: 1,
                  },
                  move: {
                    enable: true,
                    speed: 5,
                    direction: "none",
                    random: false,
                    straight: false,
                    out_mode: "out",
                    bounce: false,
                    attract: { enable: false, rotateX: 600, rotateY: 1200 },
                  },
                },
                interactivity: {
                  detect_on: "canvas",
                  events: {
                    onhover: { enable: true, mode: "grab" },
                    onclick: { enable: true, mode: "repulse" },
                    resize: true,
                  },
                  modes: {
                    grab: { distance: 0, line_linked: { opacity: 1 } },
                    bubble: {
                      distance: 400,
                      size: 40,
                      duration: 2,
                      opacity: 8,
                      speed: 3,
                    },
                    repulse: { distance: 300, duration: 0.5 },
                    push: { particles_nb: 4 },
                    remove: { particles_nb: 2 },
                  },
                },
                detectRetina: true,
            }}
        />
    );
};

export default Prticless